import React, {useContext} from "react";
import UserContext from "./UserContext";

export function isFeatureAvailable(featureKey: string) {
  const {userData, updateUserData} = useContext(UserContext);
  return userData.features.indexOf(featureKey) >= 0;
}
